import React from 'react';
import { useParams } from 'react-router';
import { CommonEmbed } from 'components/common/CommonEmbed';

export const NoticeDetail: React.FC = () => {
    const { noticeId } = useParams<{ noticeId: string }>();
    return <CommonEmbed title="공지사항" path={`/notice/${noticeId}`} />;
};
